import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Multimedia.css';

// Import the thumbnail images
import thumb1 from '../../assets/images/multimedia-thumb-1.png';
import thumb2 from '../../assets/images/multimedia-thumb-2.png';
import thumb3 from '../../assets/images/multimedia-thumb-3.png';
import featuredThumb from '../../assets/images/multimedia-featured-thumb.png'; // Thumbnail for the first video

// --- NEW DATA STRUCTURE ---
// We now have one array for all media items. Each item has all the info it needs.
const allMediaData = [
  {
    id: '2ZL-0qLlrtw?si=3EdEwJScU7w_yuKK', // YouTube Video ID
    title: "Commodity Roundup: गेहूं की सरकारी खरीद बेहतर है!| Sumit Gupta",
    description: 'इस वीडियो में हम विस्तार से बताएंगे कि गेहूं की सरकारी खरीद किसानों के लिए क्यों बेहतर विकल्प है। सरकारी खरीद के तहत न्यूनतम समर्थन मूल्य (MSP) पर फसल बेचना न सिर्फ किसानों को उचित दाम दिलाता है, बल्कि बिचौलियों से भी मुक्ति दिलाता है।',
    thumbnail: featuredThumb
  },
  {
    id: 'j3hU5YxbRh0?si=UgB4f1G_f9V4apN4', // <-- Replace with a real YouTube ID
    title: "Wheat Price Rise: Govt Tightens Wheat Stock Limits | Sumit Gupta On Measures Against Price Rise",
    description: 'Sumit Gupta discusses the governments decision to tighten wheat stock limits in response to rising wheat prices.',
    thumbnail: thumb1
  },
  {
    id: 'sRCtchdy7Fo?si=9_tNdXbdJnURrOIP', // <-- Replace with a real YouTube ID
    title: "Commodity Central | Wheat Procurement Hits 4-Year High! Will Bumper Crop Ease Prices? | Sumit Gupta",
    description: 'Wheat procurement reaches a 4-year high as strong arrivals and bumper production flood mandis. Could this lead to a softening of wheat prices amid surplus supply?',
    thumbnail: thumb2
  },
  {
    id: '-O8hLtX3-UA?si=jWrVQvOzlnEKhBU4', // <-- Replace with a real YouTube ID
    title: "Expect Wheat Supply At 116 MT This Year, Consumption At 96 MT: WASEDA Global Commodities | CNBC TV18",
    description: '‘With population growth of 1.6% +0.3% urbanisation and income growth, wheat consumption could be growing by 1.8% per annum,’ says Sumit Gupta, CEO of WASEDA Global Commodities',
    thumbnail: thumb3
  }
];


const Multimedia = () => {
  // 1. STATE: Keep track of the currently selected video. Initialize with the first video.
  const [activeVideo, setActiveVideo] = useState(allMediaData[0]);

  // 2. HANDLER: A function to change the active video when a list item is clicked.
  const handleVideoSelect = (video) => {
    setActiveVideo(video);
  };

  return (
    <section className="multimedia-section">
      <div className="section-header">
        <h2>Multimedia</h2>
        <div className="header-line"></div>
      </div>
      <p className="section-subtitle">
        Turning complex market analysis into simple, impactful visual stories.
      </p>

      <div className="multimedia-layout">
        {/* --- Left Column: Now driven by the 'activeVideo' state --- */}
        <div className="featured-media">
          <div className="video-player-wrapper">
            <iframe
              // The 'key' is important to force React to re-render the iframe when the src changes
              key={activeVideo.id} 
              src={`https://www.youtube.com/embed/${activeVideo.id}?autoplay=1`}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
          <h3>{activeVideo.title}</h3>
          <p className="video-description">
            {activeVideo.description}
          </p>
        </div>

        {/* --- Right Column: The interactive list --- */}
        <div className="media-list">
          {allMediaData.map((item, index) => (
            <div 
              key={index} 
              // Add an 'active' class if this item is the one currently playing
              className={`media-list-item ${activeVideo.id === item.id ? 'active' : ''}`}
              // 3. ONCLICK: Call the handler function when this item is clicked
              onClick={() => handleVideoSelect(item)}
            >
              <div className="list-item-image">
                <img src={item.thumbnail} alt={item.title} />
              </div>
              <div className="list-item-title">
                <h4>{item.title}</h4>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="explore-more-container">
           <Link to="/media-center">
          <button className="explore-more-btn">Explore more</button>
          </Link>   
        </div>
    </section>
  );
};

export default Multimedia;